module.exports = __webpack_public_path__ + "img/avatar-steam-account.bdbb33c8.jpg";